module.exports = __webpack_public_path__ + "static/catch-ddca6e523738e25e8c4b6c4ae34ef81f.jpg";